module.exports = __webpack_public_path__ + "static/media/eye.080b8c2b.svg";